import { useState } from "react";
import styles from "./ContactForm.module.css";
import FormAction from "./FormAction";
import FormControls from "./FormControls";

const ContactForm = () => {
  const [formData, setFormData] = useState({});
  const getFormDataHandler = (data) => {
    setFormData((prev) => {
      return { ...prev, data };
    });
  };
  const submitFormHandler = (event) => {
    event.preventDefault();
    //send contact form to server here
    console.log(formData);
  };
  return (
    <form
      className={styles.form}
      onSubmit={submitFormHandler}
    >
      <h3>CONTACT US</h3>
      <h6>
        contact us to know more about our services
      </h6>
      <FormControls
        onGetFormData={getFormDataHandler}
      />
      <p>Reply here</p>
      <FormAction />
    </form>
  );
};

export default ContactForm;
